module.exports = __webpack_public_path__ + "img/best.a9358b59.png";